"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The Timestamp class creates an small HTML element
 * and adds the current date and time to it. The class
 * lto-timestamp is added to allow CSS manipulations.
 *
 */
var Timestamp = /** @class */ (function () {
    function Timestamp() {
    }
    Timestamp.render = function () {
        var date = new Date();
        var f = function (e) { return e.toString().padStart(2, '0'); };
        var text = f(date.getHours()) + ':' + f(date.getMinutes());
        var timestamp = document.createElement('small');
        timestamp.classList.add('lto-timestamp');
        timestamp.appendChild(document.createTextNode(text));
        return timestamp;
    };
    return Timestamp;
}());
exports.Timestamp = Timestamp;
